<div *ngIf="user$ | async as _user" class="relative z-[10000]">
  <div class="cursor-pointer" *ngIf="!inlineMode" (click)="toggleDropdownMat()" (keydown.enter)="toggleDropdownMat()" role="button" tabindex="0">

    <app-avatar [userList]="[{ displayName: _user.firstName + ' ' + _user.lastName, pic: _user.pic}]" [size]="'xl'" [customClass]="'border-2 border-[#99A1B7]'" [showTooltip]="false"></app-avatar>
  </div>
  <!-- Inline dropdown shown directly -->
  <ng-container *ngIf="inlineMode">
    <ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
  </ng-container>

  <ng-template #dropdownTemplate>
    <div  #overlayPanel class="" [ngClass]="!inlineMode? 'py-2.5 rounded-xl border border-gray-100 bg-white ease-in-out duration-200 shadow-md w-[250px]' : ' pt-2 w-full'">


      <div class="flex items-center justify-between py-1.5 gap-1.5" [ngClass]="!inlineMode? 'px-5' : 'mb-2'">
        <div class="flex gap-2 min-w-0"> <!-- Added min-w-0 to allow truncation/wrapping inside -->
            <app-avatar [userList]="[{ displayName: _user.firstName + ' ' + _user.lastName, pic: _user.pic}]" [size]="'xl'" [customClass]="'border-2 border-[#17C653]'" [showTooltip]="false"></app-avatar>

          <div class="flex flex-col gap-1.5 min-w-0"> <!-- Allow wrapping inside this column -->
            <span class="text-sm text-[#252F4A] font-semibold leading-none truncate whitespace-nowrap overflow-hidden" [ngClass]="!inlineMode? 'max-w-[150px]' : ''">{{ _user.firstName }} {{ _user.lastName }}</span>
            <span class="text-xs text-[#78829D] font-medium truncate whitespace-nowrap overflow-hidden" [ngClass]="!inlineMode? 'max-w-[150px]' : ''">{{_user.email}}</span>
          </div>
        </div>
      </div>


      <div class="border border-b border-[#F1F1F4] my-2.5 divider" *ngIf="!inlineMode"></div>

      <ul class="text-sm text-[#252F4A] font-medium leading-[18px]">
        <li>
          <a href="javascript:void(0)" class="flex gap-2.5 items-center rounded-md" [ngClass]="!inlineMode? 'mx-2.5 p-2.5 hover:bg-[#f9f9f9]' : 'py-2.5'">
            <img src="../../../../../assets/images/icons/profile/profile.svg" class="shrink-0" alt="">
            <span>My Profile</span>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" class="flex gap-2.5 items-center rounded-md" [ngClass]="!inlineMode? 'mx-2.5 p-2.5 hover:bg-[#f9f9f9]' : 'py-2.5'"
             role="button" tabindex="0"
             (click)="goToBusinessProfile($event)"
             (keydown.enter)="goToBusinessProfile($event)">
            <img src="../../../../../assets/images/icons/sidebar/business-setup.svg" class="shrink-0" alt="">
            <span>Business Profile</span>
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" class="flex gap-2.5 items-center rounded-md" [ngClass]="!inlineMode? 'mx-2.5 p-2.5 hover:bg-[#f9f9f9]' : 'py-2.5'">
            <img src="../../../../../assets/images/icons/profile/change-password.svg" class="shrink-0" alt="">
            <span>Change Password</span>
          </a>
        </li>

        <!-- Finance Accounts Accordion -->
        <cdk-accordion class="w-full" *ngIf="inlineMode">
          <cdk-accordion-item>
            
            <div
              class="font-medium text-sm text-[#252F4A] flex items-center justify-between gap-2.5 py-3 cursor-pointer"
              role="button"
              tabindex="0"
              (click)="toggle('accounts', 0)"
              [attr.aria-expanded]="accordionStates['accounts'] === 0">

              <div class="flex items-center gap-2.5">
                <img src="../../../../../assets/images/icons/profile/switch-account.svg" alt="switch-account">
                <span>Switch Account</span>
              </div>

              @if (accordionStates['accounts'] === 0) {
                <img src="./assets/images/icons/global/minus.svg" alt="minus">
              } @else {
                <img src="./assets/images/icons/global/plus.svg" alt="plus">
              }
            </div>

            <div
              [@expandCollapse]="accordionStates['accounts'] === 0 ? 'expanded' : 'collapsed'"
              class="overflow-hidden">
              <ul class="font-medium text-sm text-[#6D7794] relative pl-7
                   before:content-[''] before:absolute before:top-0 before:left-2 before:w-px before:h-full before:bg-[#DBDFE9]">

                <li *ngFor="let item of businesses let i=index">
                  <a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"
                     [ngClass]="{'text-[#17C653]' : isActive(item.id)}"
                     (click)="!isActive(item.id) && setAsDefault(item); toggleDisplay()">
                    <span>{{item.name}}<i *ngIf="isActive(item.id)"></i></span>
                  </a>
                </li>
              </ul>
            </div>
          </cdk-accordion-item>
        </cdk-accordion>

        <li class="relative group submenu" *ngIf="!inlineMode">

          <a href="javascript:void(0)" class="mx-2.5 p-2.5 flex gap-2.5 items-center justify-between rounded-md hover:bg-[#f9f9f9]">
            <div class="flex gap-2.5">
              <img src="../../../../../assets/images/icons/profile/switch-account.svg" class="shrink-0" alt="">
              <span>Switch Account</span>
            </div>
            <img src="../../../../../assets/images/icons/arrows/arrow-right.svg" class="shrink-0" alt="">
          </a>

          <div class="py-2.5 rounded-xl absolute top-0 right-full border border-gray-300 w-screen max-w-[250px] overflow-hidden bg-white shadow-lg ease-in-out duration-200 opacity-0 invisible translate-y-6 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0">
            <ul class="text-sm text-[#252F4A] font-medium leading-[18px]">
              <li *ngFor="let item of businesses let i=index">
                <a href="javascript:void(0)" class="mx-2.5 p-2.5 flex gap-2.5 items-center rounded-md hover:bg-[#f9f9f9]"
                   [ngClass]="{'bg-[#f1f1f1]' : isActive(item.id), 'hover:bg-[#f9f9f9]': !isActive(item.id)}"
                   (click)="!isActive(item.id) && setAsDefault(item); toggleDisplay()">
                  <img src="../../../../../assets/images/icons/profile/download.svg" class="shrink-0" alt="">
                  <span>{{item.name}}
                    <i *ngIf="isActive(item.id)">
                  </i>
                </span>
                </a>
              </li>

            </ul>
          </div>
        </li>

        <li>
          <a href="javascript:void(0)" class="flex gap-2.5 items-center rounded-md" [ngClass]="!inlineMode? 'mx-2.5 p-2.5 hover:bg-[#f9f9f9]' : 'py-2.5'">
            <img src="../../../../../assets/images/icons/profile/download.svg" class="shrink-0" alt="">
            <span>Download</span>
          </a>
        </li>

      </ul>

      <div class="border border-b border-[#F1F1F4] my-2.5 divider"></div>
      <div [ngClass]="!inlineMode? 'mx-[18px]' : ''">

        <a href="javascript:void(0)"
           class="py-2 text-xs font-medium text-[#4B5675] border border-[#DBDFE9] rounded-md block text-center w-full hover:shadow-[0px_4px_12px_0px_rgba(0,0,0,0.09)]"
           (click)="logout()">
          Log out
        </a>

      </div>

    </div>
  </ng-template>
</div>
